import {Text} from '@/components/ui/text/Text'
import {StyledDashboardCard} from './style'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const AccessDashboardCard = ({
    title,
    children,
    endSlot
}: {
    title: string
    children: React.ReactNode
    endSlot?: React.ReactNode
}) => {
    return (
        <StyledDashboardCard>
            <Flexbox gap={1} align="center">
                <Text size="textSm" palette="neutral" shade="600">
                    {title}
                </Text>
                {endSlot}
            </Flexbox>
            {children}
        </StyledDashboardCard>
    )
}
